module.exports = __webpack_public_path__ + "img/logo5.4180d22d.png";